<label for="textbox"
       [ngClass]="labelClass"
       [ngStyle]="labelStyle">
    {{label}}
</label>
<textarea *ngIf="editMode"
          id="textbox"
          [ngClass]="{'edit': editMode}"
          [ngClass]="valueClass"
          [innerHtml]="value"
          [ngStyle]="valueStyle">
</textarea>
<p *ngIf="!editMode"
   id="textbox"
   [ngClass]="{'simple': !editMode}"
   [ngClass]="valueClass"
   [innerHTML]="value"
   [ngStyle]="valueStyle"></p>
